export default "/images/122f4a3207a194ba34513498faac03e1.avif";